export default function Crew() {
  return (
    <section id="crew" data-testid="crew-section" className="aq-bg-navy aq-section">
      <div className="aq-container grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="aq-gallery-tile" style={{ aspectRatio: "4 / 5" }}>
            <img src="/brand/aquarius_captain_vaughn.jpg" alt="Captain Vaughn Johnson at the helm of Aquarius" loading="lazy" />
          </div>
        </div>
        <div className="lg:col-span-6">
          <span className="aq-overline">The Crew</span>
          <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-foam)" }}>
            Captain Vaughn Johnson &amp; the Aquarius crew.
          </h2>
          <span className="aq-divider" />
          <p className="text-base text-[15px] leading-relaxed" style={{ color: "rgba(246, 244, 238, 0.78)" }}>
            Captain Vaughn has been tournament game-fishing the Jamaican north coast since
            childhood and running charter trips out of Ocho Rios since 2020. Alongside him is
            a 4-person deck team — First Mate, plus Munchie, Snow, Barrington and Marshal on
            rotation — most of them friends and family who've been on these waters their
            whole lives.
          </p>
          <p className="text-base text-[15px] leading-relaxed mt-4" style={{ color: "rgba(246, 244, 238, 0.78)" }}>
            First time on a sportfisher? They'll show you how to set the spread, how to
            work a marlin, and when to let the captain back the boat down on a fish.
            Seasoned? You'll like their lures.
          </p>
        </div>
      </div>
    </section>
  );
}
